import { call, put, takeLatest, fork, all, debounce } from 'redux-saga/effects';
import * as Types from '../constants/Types';
import * as Func from "../helpers/functions";
import { parseListRequestParams } from '../utils/commonUtils';
import { PATHS } from '../constants/Define';
import { get } from 'lodash';
import i18n from '../constants/initLng';
import { notification } from 'antd'
import * as VoucherService from '../services/voucherService';
import * as VoucherActions from '../actions/voucherAction';
import history from '../helpers/history';

function* getListVoucher() {
    yield takeLatest(Types.VOUCHER_LIST_ACTION, Func.sagaWrapper(function* (action) {
        const params = parseListRequestParams(action.filters || {});
        const result = yield call(VoucherService.getVouchers, params);
        yield put(VoucherActions.dataVoucherSuccess(result));
    }, errorHandleVoucher(Types.VOUCHER_FAIL)))
}

function* checkVoucher() {
    yield takeLatest(Types.VOUCHER_CHECK_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(VoucherService.checkVoucher, action.filters.data);
        if (action.filters.data) {
            yield put(VoucherActions.checkVoucherSuccess(result.data.data));
            yield put(VoucherActions.checkVoucherFailAction({ message: undefined }));
        } else {
            yield put(VoucherActions.checkVoucherSuccess(undefined));
        }
    }, errorHandleCheckVoucher(Types.VOUCHER_FAIL)))
}

function* redeemVoucher() {
    yield debounce(500, Types.VOUCHER_USED_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(VoucherService.redeemVoucher, action.filters.data);
        yield put(VoucherActions.usedVoucherSuccess({ check: true, HMSCode: result.data.data.hmsVerificationCode }));
        yield put(VoucherActions.checkVoucherAction({ data: action.filters.reCheckVoucher }));
        Func.sagaSuccessMessage(action, i18n.t('notification.usedvouchersuccess'));
    }, errorHandleRedeemVoucher(Types.VOUCHER_FAIL)))
}

function* exportExcel() {
    yield takeLatest(Types.VOUCHER_EXPORT_EXCEL_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(VoucherService.exportExcel, action.params);
        const fileName = result.headers['x-suggestion-filename'];
        const fileType = result.headers['content-type'];
        Func.downloadFile(result.data, fileName, { type: fileType });
        voucherSuccessMessage(action, `${i18n.t('notification.downloadSuccess')}`);
        yield put({ type: Types.VOUCHER_EXPORT_EXCEL_SUCCESS });
    }, errorHandleVoucher(Types.VOUCHER_EXPORT_EXCEL_FAIL)))
}

function* importVoucher() {
    yield takeLatest(Types.VOUCHER_IMPORT_ACTION, Func.sagaWrapper(function* (action) {
        const formData = new FormData();
        formData.append('file', action.params.file);
        formData.append('groupId', action.params.groupId);
        const result = yield call(VoucherService.importVoucher, formData);
        yield put(VoucherActions.importVoucherSuccess(result.data.data));
    }, errorHandleImportVoucher(Types.VOUCHER_FAIL)))
}

function* createVoucher() {
    yield takeLatest(Types.VOUCHER_CREATE_ACTION, Func.sagaWrapper(function* (action) {
        const params = action.params.data;
        yield call(VoucherService.createVoucher, params);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.201'), `${params.voucherNumber} ${i18n.t('item.voucher.title').toLowerCase()}`);
        history.push(PATHS.VOUCHER.LIST.path);
        history.go();
    }, errorHandleVoucher(Types.VOUCHER_FAIL)))
}

function* getVoucherDetail() {
    yield takeLatest(Types.VOUCHER_GET_ITEM_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(VoucherService.getVoucherDetail, action.params.id);
        yield put(VoucherActions.getItemVoucherSuccess(result));
        yield put({ type: Types.VOUCHER_GET_HISTORY_ACTION, params: action.params });
    }, errorHandleVoucher(Types.VOUCHER_FAIL)))
}

function* getVoucherHistory() {
    yield takeLatest(Types.VOUCHER_GET_HISTORY_ACTION, Func.sagaWrapper(function* (action) {
        const params = parseListRequestParams(action.params.page || {});
        const result = yield call(VoucherService.getVoucherHistory, action.params.id, params);
        yield put(VoucherActions.getHistoryVoucherSuccess(result));
    }, errorHandleVoucher(Types.VOUCHER_FAIL)))
}

// function* exVoucher(action) {
//     try {
//         let dataFilter = { ...action.filters.data, culture: i18n.t('exportLang') }
//         if (dataFilter) {
//             let params = [];
//             Object.keys(dataFilter).map((i) => {
//                 if (dataFilter[i]) {
//                     params.push(`${i}=${dataFilter[i]}`);
//                 }
//             });
//             let urlEx = params.join("&");
//             const link = `${Config.API_VOUCHER}/api/voucher/${action.filters.nameEx}?${urlEx}`;
//             const method = "GET";
//             const body = null;
//             const data = yield call(API.apiProductUrl, link, method, body, true);
//             let fileName = data.headers['x-suggestion-filename'];
//             Func.downloadFile(data.data, fileName);
//         } else {
//             const link = `${Config.API_VOUCHER}/api/voucher/${action.filters.nameEx}`;
//             const method = "GET";
//             const body = null;
//             const data = yield call(API.apiProductUrl, link, method, body, true);
//             let fileName = data.headers['x-suggestion-filename'];
//             Func.downloadFile(data.data, fileName);
//         }
//     } catch (e) {
//     }
// }

// function* showDataExVoucher() {
//     yield takeLatest(Types.VOUCHER_EXPORT_ACTION, exVoucher);
// }

function* updateVoucher() {
    yield takeLatest(Types.VOUCHER_UPDATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(VoucherService.updateVoucher, action.params.data);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.204'));
        yield put({ type: Types.GROUP_UPDATE_SUCCESS });
        if (action.params.action !== "CHECK") {
            yield put({ type: Types.VOUCHER_GET_HISTORY_ACTION, params: { id: action.params.data.id } })
            yield put({ type: Types.VOUCHER_UPDATE_SUCCESS })
        } else {
            yield put(VoucherActions.checkVoucherAction({ data: action.params.reCheckVoucher }));
        }
    }, errorHandleVoucher(Types.VOUCHER_FAIL)))
}


////////////// VOUHER NEW PROCESSES ERROR HANDLE ///////////////

function errorHandleImportVoucher(errorActionType) {
    return Func.sagaErrorHandler(function* (e) {
        const code = get(e, 'errors[0].code');
        yield put({ type: errorActionType });
        yield put(VoucherActions.importVoucherFaild(e.errors));
        if (code == 11011) {
            Func.alertMessage(i18n.t('notifi.title'), i18n.t('notifi.importCannotFindDate'), true);
        }
    }, 'voucher');
}

function errorHandleRedeemVoucher(errorActionType) {
    return Func.sagaErrorHandler(function* (e) {
        yield put(VoucherActions.usedVoucherSuccess(false));
        yield put({ type: errorActionType })
    }, 'voucher');
}

function errorHandleCheckVoucher(errorActionType) {
    return Func.sagaErrorHandler(function* (e) {
        const code = get(e, 'errors[0].code');
        const message = get(e, 'errors[0].message') || i18n.t(`validation.statusCode.code.${code || 'UNDEFINED_ERROR'}`);
        const serialNumber = get(e, 'request.serialNumber');
        yield put(VoucherActions.checkVoucherSuccess(code ? false : undefined));
        yield put(VoucherActions.checkVoucherFailAction({ message: `* ${Func.checkUndefine(serialNumber)} ${code ? i18n.t(`validation.statusCode.code.${code}`) : message}` }));
        yield put({ type: errorActionType })
    }, 'voucher');
}

function errorHandleVoucher(errorActionType) {
    return Func.sagaErrorHandler(function* (e) {
        yield put({ type: errorActionType });
    }, 'voucher');
}

function voucherSuccessMessage(action, message, description) {
    return Func.sagaSuccessMessage({ action, message, description })
}

export function* voucherSaga() {
    yield all([
        fork(getListVoucher),
        fork(checkVoucher),
        fork(redeemVoucher),
        // fork(showDataExVoucher),
        fork(importVoucher),
        fork(createVoucher),
        fork(getVoucherDetail),
        fork(getVoucherHistory),
        fork(updateVoucher),

        //// Voucher new processes
        fork(exportExcel),
    ])
}
